import { BaseConfig } from '../ServiceConfig';

export interface USConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.UserServiceConfigData';
  url: string;
  clientCode: string;
  operationFlow: string;
  isDealerRequired: boolean;
  isProfileRequired: boolean;
}

export const USConfigurationFields: (keyof USConfiguration)[] = [
  'url',
  'clientCode',
  'operationFlow',
  'isDealerRequired',
  'isProfileRequired',
];

export const BlankUSConfiguration: USConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.UserServiceConfigData',
} as USConfiguration;
